import { apiRequest } from './apiInterceptor'; // Assuming apiInterceptor is set up
import { createQueryString } from './apiService'; // Import createQueryString

const BASE_URL = '/api/userfolder';

const userFolderService = {
  getAllFolders: (queryParams = {}) => {
    // console.log('[userFolderService] 📡 getAllFolders called with params:', queryParams);
    const queryString = createQueryString(queryParams);
    const result = apiRequest(`${BASE_URL}${queryString}`, { method: 'GET' });
    // console.log('[userFolderService] 📤 getAllFolders returning promise');
    return result;
  },

  getFolderById: (id) => {
    return apiRequest(`${BASE_URL}/${id}`, { method: 'GET' });
  },

  createFolder: (folderData) => {
    // folderData should be { Name: "string", Description: "string" } as per api.md
    return apiRequest(BASE_URL, {
      method: 'POST',
      body: JSON.stringify(folderData)
    });
  },

  updateFolder: (id, folderData) => {
    // folderData should be { Name: "string", Description: "string" } as per api.md
    return apiRequest(`${BASE_URL}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(folderData)
    });
  },

  deleteFolder: (id) => {
    return apiRequest(`${BASE_URL}/${id}`, { 
      method: 'DELETE' 
    });
  },

  getQuestionsInFolder: (id, queryParams = {}) => {
    const queryString = createQueryString(queryParams);
    return apiRequest(`${BASE_URL}/${id}/questions${queryString}`, { method: 'GET' });
  },

  addQuestionToFolder: (folderId, questionId) => {
    return apiRequest(`${BASE_URL}/${folderId}/questions/${questionId}`, {
      method: 'POST'
      // No body needed for this specific POST as per API spec
    });
  },

  removeQuestionFromFolder: (folderId, questionId) => {
    return apiRequest(`${BASE_URL}/${folderId}/questions/${questionId}`, { 
      method: 'DELETE' 
    });
  },

  getSpecificSavedQuestionInFolder: (folderId, questionId) => {
    return apiRequest(`${BASE_URL}/${folderId}/questions/${questionId}`, { method: 'GET' });
  },
};

export default userFolderService;